var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + ("\u003Cdiv ui-view=\"supportMain\"\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = require("../../helpers/_footer.pug").call(this, locals)) ? "" : pug_interp));;return pug_html;};
module.exports = template;